import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setTransferOrderList } from '../../../../Redux/services/serviceSlice';
import { setUserData } from '../../../../Redux/user/userSlice';
const apiUrl = process.env.REACT_APP_OMS_NEST_API
// const apiUrl = 'http://localhost:3008/rest/v1';

export const fetchTOList = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'GET',
    url: `${apiUrl}/order/get-to-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    params: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(setTransferOrderList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      dispatch(setTransferOrderList([]));
    }
  }
};

export const fetchStaffRequests = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'GET',
    url: `${apiUrl}/order/get-staff-requested-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    params: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
}

export const createTO = async ({ data, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/order/create-service-to`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: data,
  };
  try {
    const response = await axios(config);
    fetchTOList({ params: {}, dispatch });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

export const returnTO = async ({ data, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/order/return-service-to`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: data,
  };
  try {
    const response = await axios(config);
    fetchTOList({ params: {}, dispatch });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};


export const searchServiceItemSKU = async ({ dispatch, params }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'GET',
    url: `${apiUrl}/order/get-service-item-by-sku?sku=${params?.sku}`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
}